/**
 * Contains information useful for configuring Paychex applications.
 *
 * ```js
 * import { tracker } from '~/path/to/tracker.js';
 * import { fetch, createRequest } from '~/path/to/datalayer.js';
 *
 * import { data } from '@paychex/core';
 * import { config, data as internal } from '@paychex/internal';
 *
 * const endpoints = config.endpoints.concat([
 *     {
 *         "name": "My Project Health Endpoint",
 *         "base": "my-project",
 *         "path": "/health",
 *     }
 * ]);
 *
 * const options = {
 *   fetch,
 *   createRequest,
 *   tracker,
 * };
 *
 * const diagnostics = internal.createDiagnostics(options, endpoints);
 * const pipeline = data.utils.withDiagnostics(fetch, diagnostics);
 * ```
 * @module config
 */

import { Endpoint } from '../data';

import urls from './endpoints';

/**
 * These endpoints verify connectivity to standard 3rd party websites used by Paychex. You
 * can include and extend these endpoints when {@link createDataPipeline constructing a data pipeline}
 * or {@link createDiagnostics creating a Diagnostics function}.
 */
export const endpoints: Endpoint[] = urls;
